// -------------
// this is the registration of all default flow data
// -------------

import { RegisterFlowStepData } from "./RegisterFlowStepData";
import { MultiOutputTestStep } from "../Steps/ExampleSteps/MultiOutputTestStep";
import { ManyOutputTestStep } from "../Steps/ExampleSteps/ManyOutputTestStep";
import { LongOutputTestStep } from "../Steps/ExampleSteps/LongOutputTestStep";
import { FormStep } from "../Steps/UI/FormStep";
import { RunExpression } from "../Steps/Expressions/RunExpression";
import { RunStatementRule } from "../Steps/Rules/RunStatementRule";
import { RunRuleTable } from "../Steps/Rules/RunRuleTable";
import { RunValueTable } from "../Steps/Rules/RunValueTable";
import { RunIntersectionRule } from "../Steps/Rules/RunIntersectionRule";
import { RunTreeRule } from "../Steps/Rules/RunTreeRule";
import { RunRuleSet } from "../Steps/Rules/RunRuleSet";
import { RunFlow } from "../Steps/General/RunFlow";
import { SaveFlowData } from "../Steps/General/SaveFlowData";
import { LogStep } from "../Steps/General/LogStep";
import { SequenceEndStep } from "../Steps/General/SequenceEndStep";

export class RegisterFlowStepDatas {
    static isRegistered = false;

    static doRegistration() {
        if (RegisterFlowStepDatas.isRegistered) return;

        RegisterFlowStepDatas.isRegistered = true;

        // this one must be first as it is used by others
        RegisterFlowStepData(new SequenceEndStep(), "SequenceEndStep", false);

        RegisterFlowStepData(new MultiOutputTestStep(), "Multiple Paths", true);
        RegisterFlowStepData(new ManyOutputTestStep(), "Multiple Paths - Many", true);
        RegisterFlowStepData(new LongOutputTestStep(), "Multiple Paths - Long", true);

        RegisterFlowStepData(new FormStep(), "Form", true);

        RegisterFlowStepData(new RunExpression(), "Run Expression", true);

        RegisterFlowStepData(new RunStatementRule(), "Run Statement Rule", true);
        RegisterFlowStepData(new RunRuleTable(), "Run Rule Table", true);
        RegisterFlowStepData(new RunValueTable(), "Run Value Table", true);
        RegisterFlowStepData(new RunIntersectionRule(), "Run Intersection Rule", true);
        RegisterFlowStepData(new RunTreeRule(), "Run Tree Rule", true);
        RegisterFlowStepData(new RunRuleSet(), "Run Rule Set", true);

        RegisterFlowStepData(new RunFlow(), "Run Flow", true);
        RegisterFlowStepData(new SaveFlowData(), "Save Flow", true);

        RegisterFlowStepData(new LogStep(), "Log", true);
    }
}
